export enum PartenaireTypeEnum {
  EntrepriseTravaux = '3 - Entreprise de travaux',
  Entreprise = '4 - GC Entreprise',
  BailleurSocial = '6 - GC Bailleur social',
  BureauEtude = "10- Bureau d'étude",
  ResidentielCollectif = 'Résidentiel Collectif',
}
